import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicProductPriceParamsRawI,
	type LWApiPublicProductPriceResultRawI,
} from '@liquidweb-dev/club-sauce/public/product/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const PRODUCT_PRICE_QUERY_KEY = '/product/price';

const useProductPrice = (
	params: LWApiPublicProductPriceParamsRawI,
	options?: UseQueryOptions<LWApiPublicProductPriceResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [PRODUCT_PRICE_QUERY_KEY, params],
		queryFn: () => api.product.apiRaw.price(params),
		...options,
	});

export default useProductPrice;
